module.exports = __webpack_public_path__ + "img/youtube_transparent.48cec570.svg";